import { Pipe, PipeTransform } from '@angular/core';

import {PredicateModel} from '@app/core/model/filtering/predicate-model';
import {MetadataModel} from '@app/core/model/filtering/metadata-model';

@Pipe({
    name: 'ngcGetPredicatesList'
})
export class GetPredicatesListPipe implements PipeTransform {

    constructor() {}

    transform(predicatesMetadata: MetadataModel[], propertyTypeDenom: string, propertyName: string): any {

        return this.getPredicatesList(predicatesMetadata, propertyTypeDenom, propertyName);
    }

    private getPredicatesList(predicatesMetadata: MetadataModel[], propertyTypeDenom: string, propertyName: string): PredicateModel[] {
        let metadataItem;

        if (propertyName) {
            metadataItem = predicatesMetadata
                .find((predicateMetadata: MetadataModel) => predicateMetadata.type === propertyTypeDenom);
        }

        return metadataItem ? metadataItem.predicates : [];
    }
}
